export default __webpack_public_path__ + "static/media/project.c2e2b05c.png";